import * as React from 'react';
import { createPortal } from 'react-dom';
import { IOdd, IDesktopLiveEventListStore, getSportClassByPresentationId } from 'eTip--common';
import { Tooltip, Blinker, CategoryIcon } from 'common--design-library';
import { EventOdds, EventsPopup, ILeftMenuCategoryPopupEvent } from 'desktop--design-library';
import { observer } from 'mobx-react';

export namespace LeftMenuCategoryNS {

    export interface ILiveCategory {
        id: number;
        name: string;
        isExpandedInLeftMenu: boolean;
        graphicsPresentationId: number; eventCount: number;
        events: IDesktopLiveEventListStore[],
        isFavorite: boolean;
        toggleIsExpandedInLeftMenu: () => void;
    }; //TODO event types

    export interface ILeftMenuCategoryProps {
        category: ILiveCategory;
        isEventPopUpVisible: boolean;
        activeTips: { [key: string]: string };
        inactiveTips: { [key: string]: string };
        isLeftColumnCollapsed: boolean;
        popupOffset: number;
        isFavorite: boolean;
        onSelectTip: (odd: IOdd, event: any) => void;
        onSetAsFavorite: (eventId: number, isFavorite: boolean) => void;
        onToggleExpand: () => void;
        goToDetail: (detailId: number, canOpenLiveStream?: boolean) => void;
        onToggleEventsPopupVisible: (offset: number) => void;
        onSetCategoryFavorite: () => void;
        onMatchTrackerClick: (event: IDesktopLiveEventListStore) => void;
    }
}


export const LeftMenuCategory: React.FC<LeftMenuCategoryNS.ILeftMenuCategoryProps> = observer((props) => {
    /**
     * although component, without observer it does not update the left column (5.8.2021). Model is updated inside, no new instances for each update.
     */
    const category = props.category;
    const sportName = getSportClassByPresentationId(category.graphicsPresentationId);

    const handleEventPopupOpen = (offset: number) => {
        props.onToggleEventsPopupVisible(offset);
    }

    let lastCategoryPath: string = null;

    const renderGameDetail = (event: IDesktopLiveEventListStore) => {
        return event.gameAndDetailForLeftMenu &&
            <EventOdds
                activeTips={props.activeTips}
                inactiveTips={props.inactiveTips}
                gameDetail={event.gameAndDetailForLeftMenu.detail}
                setTipOnCoupon={(odd: IOdd) => { props.onSelectTip(odd, event) }}
            />
    }

    return props.isLeftColumnCollapsed
        ? <React.Fragment>
            <div className={`left-menu-category left-menu-category-collapsed title`} onClick={(e) => { handleEventPopupOpen(e.clientY) }}>
                <CategoryIcon categoryIconId={category.graphicsPresentationId} small />
                <span className={`text-uppercase ml-1 `}>({category.eventCount})</span>
            </div>
            {
                props.isEventPopUpVisible &&
                createPortal(
                    <EventsPopup
                        sportName={sportName}
                        categoryName={category.name}
                        eventCount={category.eventCount}
                        events={category.events.map(event => {
                            return {
                                id: event.id,
                                isFavorite: category.isFavorite,
                                name: event.name,
                                hasResults: event.hasResults,
                                mainResult: event.mainResult,
                                stateName: event.stateName,
                                eventTime: event.eventTime

                            } as ILeftMenuCategoryPopupEvent
                        })}
                        onSetAsFavorite={props.onSetAsFavorite}
                        goToDetail={props.goToDetail}
                        onToggleEventsPopupVisible={props.onToggleEventsPopupVisible}
                        popupOffset={props.popupOffset}
                    />
                    , document.body)
            }
        </React.Fragment>
        : <div className="left-menu-category left-menu-category-expanded" key={`${category.id}`} style={{ marginTop: "15px" /* TODOHL */ }}>
            <div className={`title d-flex p-1`}>
                <CategoryIcon categoryIconId={category.graphicsPresentationId} small />
                <span className={`text-uppercase ${sportName}-color`}>
                    <span className="mx-1">{category.name}</span>
                    ({category.eventCount})
                    <a style={{ cursor: "pointer" }} onClick={() => { props.onToggleExpand(); }}>
                        <i className={"ml-1 fa " + (category.isExpandedInLeftMenu ? "fa-caret-up" : "fa-caret-down")}></i>
                    </a>
                </span>
                {
                    !props.isFavorite &&
                    <div className="ml-auto">
                        <span className="far fa-star category-favorite-icon" onClick={() => { props.onSetCategoryFavorite() }}></span>
                    </div>
                }
            </div>
            <div className={"events" + (category.isExpandedInLeftMenu ? "" : " d-none")}>
                {category.isExpandedInLeftMenu && category.events.map(event => {
                    const canShowCategoryPath = event.categoryPath !== lastCategoryPath;
                    lastCategoryPath = event.categoryPath;
                    return <React.Fragment key={`ce_${event.id}`}>
                        {canShowCategoryPath && <div className="region">{event.categoryPath}</div>}
                        <div className="event">
                            <div className="d-flex px-1 justify-content-between">
                                <a className={`text-truncate text-uppercase`} style={{ cursor: "pointer" }}
                                    onClick={() => { props.goToDetail(event.id) }}>
                                    <Tooltip
                                        targetid={`tooltip_l_${event.id}`} placement="top-end" autohide={false}
                                        targetFactory={(p) => <div {...p} className="text-truncate  event-name">
                                            {event.matchTracker ? <i className={"fa fa-eye mr-1"} onClick={(e) => { e.stopPropagation(); props.onMatchTrackerClick(event); }}></i> : null}
                                            {event.liveStream ? <i className={"fa fa-desktop mr-1"} onClick={(e) => { e.stopPropagation(); props.goToDetail(event.id, true); }}></i> : null}
                                            {event.name}
                                        </div>}
                                    >
                                        <div className="p-2 text-left">
                                            {event.name}<br />
                                            {event.categoryPath}<br />
                                            {event.hasResults && <span>{event.mainResult.score1}:{event.mainResult.score2}</span>}
                                        </div>
                                    </Tooltip>
                                </a>
                                <div style={{ cursor: "pointer" }}>
                                    <span className={`${props.isFavorite ? "fa fa-star" : "far fa-star"}`}
                                        onClick={(e) => { e.stopPropagation(); props.onSetAsFavorite(event.id, props.isFavorite) }}>
                                    </span>
                                </div>
                            </div>
                            <div className="px-1 score-wrapper">
                                <span className="event-state">{event.stateName}{event.eventTime > 0 && <>, {event.eventTime}'</> /* same in eventsPopup */}</span>
                                {event.hasResults && <span className={__IsMTSTipos__ ? null : "main-result"}><Blinker value={Number(event.mainResult.score1)} /> : <Blinker value={Number(event.mainResult.score2)} /></span>}
                            </div>
                            {
                                __IsMTSTipos__ ? <div className="px-1">
                                    {
                                        renderGameDetail(event)
                                    }
                                </div>
                                    :
                                    renderGameDetail(event)
                            }
                        </div>
                    </React.Fragment>
                })}
            </div>
        </div >
});